import React from "react";

import FaderLogo from "./logo.js";

class TopExpanded extends React.Component {
  render() {
    console.log("TopExpanded");

    return (
      <section class="top">
        <div class="top-upper">
          <div class="top-left" />

          <div class="top-middle">
            <div class="site-logo">
              <a href="/">
                <FaderLogo />
              </a>
            </div>
          </div>

          <div class="top-right" />
        </div>

        <div class="top-lower">
          <div class="top-left" />

          <div class="top-middle">
            <div class="nav-link">
              <a href="/music">MUSIC</a>
            </div>

            <div class="nav-link">
              <a href="/style">STYLE</a>
            </div>

            <div class="nav-link">
              <a href="/culture">CULTURE</a>
            </div>

            <div class="nav-link">
              <a href="/magazine">MAGAZINE</a>
            </div>

            <div class="nav-link">
              <a href="https://shop.thefader.com">SHOP</a>
            </div>
          </div>

          <div class="top-right">{this.renderSocials()}</div>
        </div>
      </section>
    );
  }

  renderSocials() {
    return (
      <div class="social-icons">
        <div id="new_socials_bottom" class="new_socials_footer  ">
          <a
            target="new"
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Flocalhost%3A3000%2F2019%2F10%2F23%2Fwale-wow-thats-crazy-album-interview%3Futm_source%3Df%26utm_medium%3Dfb%26utm_campaign%3Dshare"
            class="new_social_footer_button facebook new_social_share_button"
            data-ga-event-category="Social Share"
            data-ga-event-label="Facebook"
            data-ga-on="click"
            data-ga-event-action="cilck"
          >
            <img
              class=""
              width="40"
              height="40"
              src="/assets/FDR_SocialSharing_Facebook-747312c39722d47504a80f02500b8d4ad2e36acf922bad1c83799db1bc77f605.png"
              alt="Fdr socialsharing facebook"
            />
          </a>

          <a
            target="new"
            href="https://twitter.com/intent/tweet?url=https%3A%2F%2Flocalhost%3A3000%2F2019%2F10%2F23%2Fwale-wow-thats-crazy-album-interview%3Futm_source%3Df%26utm_medium%3Dtw%26utm_campaign%3Dshare&amp;text=Wale’s push for clarity &amp;via=thefader"
            class="new_social_footer_button twitter new_social_share_button"
            data-ga-event-category="Social Share"
            data-ga-event-label="Twitter"
            data-ga-on="click"
            data-ga-event-action="cilck"
          >
            <img
              class=""
              width="40"
              height="40"
              src="/assets/FDR_SocialSharing_Twitter-8d78f695280aa3f8a4461702c68e9fcbfd6042af1600c62d49fdec4b735fb57a.png"
              alt="Fdr socialsharing twitter"
            />
          </a>

        </div>
      </div>
    );
  }

  renderSocialsSvg() {
    return (
      <div class="social-icons">
        <div class="social-icon">
          <a href="#">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-label="Facebook"
              role="img"
              viewBox="0 0 512 512"
            >
              <rect width="512" height="512" rx="15%" fill="#1877f2" />
              <path
                d="M355.6 330l11.4-74h-71v-48c0-20.2 9.9-40 41.7-40H370v-63s-29.3-5-57.3-5c-58.5 0-96.7 35.4-96.7 99.6V256h-65v74h65v182h80V330h59.6z"
                fill="#fff"
              />
            </svg>
          </a>
        </div>
        <div class="social-icon">
          <a href="#">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-label="Twitter"
              role="img"
              viewBox="0 0 512 512"
            >
              <rect width="512" height="512" rx="15%" fill="#1da1f3" />
              <path
                fill="#fff"
                d="M437 152a72 72 0 0 1-40 12 72 72 0 0 0 32-40 72 72 0 0 1-45 17 72 72 0 0 0-122 65 200 200 0 0 1-145-74 72 72 0 0 0 22 94 72 72 0 0 1-32-7 72 72 0 0 0 56 69 72 72 0 0 1-32 1 72 72 0 0 0 67 50 200 200 0 0 1-105 29 200 200 0 0 0 309-179 200 200 0 0 0 35-37"
              />
            </svg>
          </a>
        </div>
      </div>
    );
  }
}

export default TopExpanded;
